import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3 bg-white border-round-lg mb-3" }
const _hoisted_2 = { class: "flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "font-bold text-lg" }
const _hoisted_5 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["innerHTML"]

import { computed, ref, toRefs } from 'vue';
import { Attendee, DetailedEventInterface, PastResultInterface } from '@/types';
import PastDocumentationGoal from '@/views/Calendar/components/PastDocumentationGoal.vue';

interface Props {
  event: DetailedEventInterface;
  attendee: Attendee;
  therapyResult: PastResultInterface['result'];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentationItem',
  props: {
    event: {},
    attendee: {},
    therapyResult: {}
  },
  setup(__props: any) {

const props = __props;
const { event, attendee, therapyResult } = toRefs(props);

const goalsMeasurements = computed(() => {
  return therapyResult.value?.goals_measurements.filter((goal) => goal.id);
});

const isSessionEvent = event.value.therapy_event_type === 'Session';

const getSessionType = (studentId: number) => {
  if (!isSessionEvent) return;

  const sessionType = event.value.event_type_data?.session_types?.find(
    (sessionType) => sessionType.person_id === studentId,
  );

  const shortNames = {
    Regular: 'Reg.',
    'Approved Compensation': 'Approved Comp.',
    'Extended School Year': 'Extended School Year',
    'Make up': 'Make up',
  };

  return shortNames[sessionType?.therapy_session_type.name];
};

const isDocumented = ref(!!therapyResult.value?.id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(attendee).attendee.full_name), 1),
        (isDocumented.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("span", {
                class: "mx-2",
                style: {"border-left-style":"solid","border-left-width":"2px","border-left-color":"#d4d9d9","height":"20px"}
              }, null, -1)),
              _createElementVNode("p", null, _toDisplayString(_unref(therapyResult).therapy_result_type.name), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      isSessionEvent
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _cache[1] || (_cache[1] = _createTextVNode(" Session Type: ", -1)),
            _createElementVNode("b", null, _toDisplayString(getSessionType(_unref(attendee).attendee_id)), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", {
      class: "mt-3",
      innerHTML: _unref(attendee).notes
    }, null, 8, _hoisted_7),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goalsMeasurements.value, (goal) => {
      return (_openBlock(), _createBlock(PastDocumentationGoal, {
        key: goal.id,
        data: goal
      }, null, 8, ["data"]))
    }), 128))
  ]))
}
}

})